<template>
  <div class="checkmark-row">
    <div class="checkmark-row__icon">
      <SvgIcon
        :image="IconCheck"
        class="icon checkmark-row__icon-asset"
      />
    </div>
    <div class="checkmark-row__text">
      <span>{{ checkmarkText }}</span>
    </div>
  </div>
</template>

<script>
import IconCheck from '@/assets/images/check.svg';
import SvgIcon from '@/components/svg-icon.vue';

export default {
  name: 'CheckmarkText',
  components: {
    SvgIcon,
  },
  props: {
    checkmarkText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      IconCheck,
    };
  },
};
</script>

<style lang="scss">
@use 'assets/base' as *;

.checkmark-row {
  display: flex;

  &__icon {
    margin-right: 15px;
    width: 20px; // IE Bugfix
  }

  &__icon-asset {
    color: #6bb324;
  }

  &__text {
    @include font-size(18px, 27px);
  }
}
</style>
